// extracted by mini-css-extract-plugin
export var lastUpdatedChip = "x_bS";
export var legalWrapper = "x_bR";